<template>
  <div>
    <div class="dialog-body-wrap">
      <div>
        <div class="item-wrap">
          <label>身份名称:</label>
          <el-input v-model="addBody.group_title" placeholder="请输入身份名称" class="name_input"></el-input>
        </div>
        <div class="item-wrap">
          <label>管理模块:</label>
          <el-tree :data="powerTree" show-checkbox :default-expand-all="false"
                   node-key="menu_id" ref="tree" :props="defaultProps"/>
        </div>
      </div>
      <div class="btn-wrap">
        <el-button @click="onCancelClick">取消</el-button>
        <el-button type="primary" @click="onSaveClick">确定</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import CommonDialog from "@/components/CommonDialog";
import {
  LimitsList,
  getPermissionList,
  getIdentityPerssion,
  addLimitsUser,
  SetLimitsList,
  delLimitsUser,
  getIdentityDetail, getMenuList, readMenu
} from "@/api/auth";
import {
  mapState
} from "vuex";

export default {
  data() {
    return {
      powerTree: [],
      hadPermissionIdList: [],
      defaultProps: {
        children: "children",
        name: "menu_name"
      },
      addBody: {
        group_title: "",
        rules_url: [],
        store_uuid: [],
        rules: [],
        rules_name: [],
        oneId: [] //存放所有一级菜单id
      },
      identityUuid: '',
      parent_rules: [], //一、二级列表的权限id
      type: "add",
      detailInfo: {},
      seconde_rule: [],
      defaultCheckedKeys: []
    };
  },
  components: {},
  // async mounted() {
  //  this.activated()
  // },
  async mounted() {
    const {
      group_id,
      group_title,
      permissionList
    } = this.$route.query;
    this.addBody.group_title = group_title;
    //this.permissionList = permissionList;
    await this.getLimitList();
    if (group_id) {
      this.type = "edit";
      this.identityUuid = group_id;
      this._getIdentityDetail(group_id);
      //this.setData();
    } else {
      this.type = "add";
      this.identityUuid = "",
          this.addBody = {
            group_title: "",
            rules_url: [],
            store_uuid: [],
            rules: [],
            rules_name: [],
            oneId: [] //存放所有一级菜单id
          };
      // this.$refs.tree.setCheckedKeys([]);
    }
  },
  computed: {
    ...mapState(["hotelData"])
  },
  methods: {
    async _getIdentityDetail(id) {
      const {
        status,
        data
      } = await getIdentityPerssion({
        group_id: id
      });
      if (status === 200) {
        //this.detailInfo = data;
        this.setData(data);
        // this.defaultCheckedKeys = JSON.parse(this.$route.query.rules)
      }
    },
    async getLimitList() {
      let postData = {
        page_index: 1,
        page_size: 1000
      }
      const {
        data,
        status
      } = await getMenuList(postData);
      if (status !== 200) return;
      let copyData = data.result.data;
      if (copyData.length) {
        // .filter(item => item.type != 3)
        var permissionList = copyData;
        var three = copyData.filter(item => item.level == 3);
        var one = permissionList.filter(item => item.level == 1);
        var two = permissionList.filter(item => item.level == 2);
        this.parent_rules = permissionList.map(item => item.menu_id);
        one.forEach(one => {
          const children = [];
          two.forEach(two => {
            var twoChildren = []
            three.forEach(three => {
              if (two.menu_id == three.pid) {
                three.label = three.menu_name;
                twoChildren.push(three);
                two.children = twoChildren
              }
            })
            if (one.menu_id == two.pid) {
              two.label = two.menu_name;
              children.push(two);
              one.children = children
            }

          })
          one.label = one.menu_name;
        })

        // copyData.forEach(one => {
        // 	console.log(one.son_rule.length)
        // 	if (one.son_rule.length) {
        // 		this.parent_rules.push(one.id);
        // 	}
        // 	one.son_rule.forEach(two => {
        // 		//存放二级列表权限id
        // 		console.log(two.son_rule.length)
        // 		if (two.son_rule.length) {
        // 			this.parent_rules.push(two.id);
        // 		}
        // 		two.son_rule.forEach(three => {
        // 			three.label = three.name
        // 		})
        // 		two.label = two.name;
        // 	});
        // 	one.label = one.name;
        // });
        this.powerTree = one;
        // let newArray = []
        // this.checked(one,newArray)
        // this.powerTree = newArray
      }
      setTimeout(() => {
        // this.defaultCheckedKeys = JSON.parse(this.$route.query.rules)
      }, 500)
    },
    setData: function (data) {
      //只有两级把一级权限去掉 如果有三级就把一级和二级 权限去掉。否则权限会处于全选状态
      //获取权限列表的时候做了处理 符合的才会放到parent_rules里
      let row = data.result.menu_rules;
      let newArr = [];
      this.checked(row, newArr);
      let rules = newArr.filter(item => {
        return this.parent_rules.includes(item.menu_id);
      });
      if (row && row.length) {
        this.$nextTick(() => {
          this.$refs.tree.setCheckedNodes(rules);
        });
      }
    },
    checked(data, newArr) { //这个函数是在检查id是否是父级id 将子级id过滤出来 运用到了递归
      data.forEach((item) => {

        // item.label = item.rules_name;
        // item.menu_name = item.rules_name;
        // item.menu_url = item.rules_url;
        newArr.push({
          menu_id: parseInt(item)
        });
      })
      return newArr;
    },
    onCancelClick() {
      this.$router.go(-1);
    },
    async onSaveClick() {
      const tree = this.$refs.tree.getCheckedNodes(true);
      const {
        group_title
      } = this.addBody;
      if (!group_title) {
        this.$message("请输入身份名称");
        return;
      }
      if (!tree.length) {
        this.$message("请选择权限");
        return;
      }
      let fidArr = tree.map(item => item.menu_id);
      let fNameArr = tree.map(item => item.menu_name);
      let fUrlArr = tree.map(item => item.menu_url);
      if (this.powerTree.length) {
        this.powerTree.forEach(one => {
          if (one.children != undefined) {
            one.children.forEach(two => {
              //存放二级列表权限id
              if (fidArr.includes(two.menu_id)) {
                fidArr.push(one.menu_id)
                fNameArr.push(one.menu_name);
                fUrlArr.push(one.menu_url);
              }
              if (two.children && two.children.length) {
                two.children.forEach(three => {
                  if (fidArr.includes(three.menu_id)) {
                    fidArr.push(one.menu_id)
                    fNameArr.push(one.menu_name);
                    fUrlArr.push(one.menu_url);
                    fidArr.push(two.menu_id)
                    fNameArr.push(two.menu_name);
                    fUrlArr.push(two.menu_url);
                  }
                })
              }
            });
          }
        });
      }
      let resultIdList = [...new Set(fidArr)];
      let resultNameList = [...new Set(fNameArr)];
      let resultUrlList = [...new Set(fUrlArr)];
      let postData = {
        group_id: this.identityUuid,
        group_title: group_title,
        status: 1,
        menu_rules: resultIdList,
        // rules_url: resultUrlList,
        // rules_name: resultNameList
      }
      if (this.type == "edit") {
        postData.uuid = this.identityUuid
      }
      switch (this.type) {
        case "add": {
          const {
            status
          } = await addLimitsUser(postData);
          if (status === 200) {
            this.$router.go(-1);
          }
          break;
        }
        case "edit": {
          const {
            data,
            status
          } = await SetLimitsList(postData);
          if (status === 200) {
            this.$router.go(-1);
          }
          break;
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.dialog-body-wrap {
  text-align: center;

  .item-wrap {
    display: flex;
    margin-bottom: 30px;

    label {
      width: 80px;
      margin-right: 40px;
    }

    .name_input {
      width: 200px;
    }
  }

  .btn-wrap {
    margin-top: 50px;
  }
}
</style>
